import React, { useState } from 'react';
import { 
  Save, 
  User, 
  Shield, 
  Bell, 
  Mail,
  Phone,
  Globe,
  Key,
  Database,
  AlertTriangle
} from 'lucide-react';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const [settings, setSettings] = useState({
    profile: {
      nom: 'Admin',
      prenom: 'Système',
      email: 'admin@smsgateway.com',
      telephone: '+33123456789',
      role: 'admin'
    },
    sms: {
      api_key: 'sk_1234567890abcdef',
      api_secret: '••••••••••••••••',
      sender_name: 'MonEntreprise',
      webhook_url: 'https://api.monentreprise.com/webhook/sms',
      max_sms_per_day: 1000,
      max_sms_per_hour: 100
    },
    notifications: {
      email_notifications: true,
      sms_notifications: false,
      campaign_completed: true,
      delivery_failed: true,
      daily_summary: true,
      weekly_report: true
    },
    security: {
      two_factor_auth: false,
      session_timeout: 30,
      password_expiry: 90,
      login_attempts: 5
    }
  });

  const tabs = [
    { id: 'profile', name: 'Profil', icon: User },
    { id: 'sms', name: 'Configuration SMS', icon: Phone },
    { id: 'notifications', name: 'Notifications', icon: Bell },
    { id: 'security', name: 'Sécurité', icon: Shield },
    { id: 'api', name: 'API', icon: Key },
    { id: 'database', name: 'Base de données', icon: Database },
  ];

  const handleInputChange = (section, field, value) => {
    setSettings(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value
      }
    }));
  };

  const handleSave = () => {
    // Ici vous pourriez sauvegarder les paramètres
    console.log('Sauvegarde des paramètres:', settings);
    alert('Paramètres sauvegardés avec succès !');
  };

  const renderProfileSettings = () => (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-secondary-900">Informations personnelles</h3>
        <p className="text-sm text-secondary-500">Gérez vos informations de profil</p>
      </div>
      
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <div>
          <label className="block text-sm font-medium text-secondary-700">Nom</label>
          <input
            type="text"
            className="input mt-1"
            value={settings.profile.nom}
            onChange={(e) => handleInputChange('profile', 'nom', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-secondary-700">Prénom</label>
          <input
            type="text"
            className="input mt-1"
            value={settings.profile.prenom}
            onChange={(e) => handleInputChange('profile', 'prenom', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-secondary-700">Email</label>
          <input
            type="email"
            className="input mt-1"
            value={settings.profile.email}
            onChange={(e) => handleInputChange('profile', 'email', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-secondary-700">Téléphone</label>
          <input
            type="tel"
            className="input mt-1"
            value={settings.profile.telephone}
            onChange={(e) => handleInputChange('profile', 'telephone', e.target.value)}
          />
        </div>
      </div>
    </div>
  );

  const renderSmsSettings = () => (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-secondary-900">Configuration SMS</h3>
        <p className="text-sm text-secondary-500">Paramètres de l'API SMS</p>
      </div>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-secondary-700">Clé API</label>
          <input
            type="text"
            className="input mt-1"
            value={settings.sms.api_key}
            onChange={(e) => handleInputChange('sms', 'api_key', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-secondary-700">Secret API</label>
          <input
            type="password"
            className="input mt-1"
            value={settings.sms.api_secret}
            onChange={(e) => handleInputChange('sms', 'api_secret', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-secondary-700">Nom de l'expéditeur</label>
          <input
            type="text"
            className="input mt-1"
            value={settings.sms.sender_name}
            onChange={(e) => handleInputChange('sms', 'sender_name', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-secondary-700">URL Webhook</label>
          <input
            type="url"
            className="input mt-1"
            value={settings.sms.webhook_url}
            onChange={(e) => handleInputChange('sms', 'webhook_url', e.target.value)}
          />
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label className="block text-sm font-medium text-secondary-700">Max SMS par jour</label>
            <input
              type="number"
              className="input mt-1"
              value={settings.sms.max_sms_per_day}
              onChange={(e) => handleInputChange('sms', 'max_sms_per_day', parseInt(e.target.value))}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-secondary-700">Max SMS par heure</label>
            <input
              type="number"
              className="input mt-1"
              value={settings.sms.max_sms_per_hour}
              onChange={(e) => handleInputChange('sms', 'max_sms_per_hour', parseInt(e.target.value))}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const renderNotificationSettings = () => (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-secondary-900">Préférences de notification</h3>
        <p className="text-sm text-secondary-500">Configurez comment vous souhaitez être notifié</p>
      </div>
      
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <label className="text-sm font-medium text-secondary-700">Notifications par email</label>
            <p className="text-sm text-secondary-500">Recevoir des notifications par email</p>
          </div>
          <input
            type="checkbox"
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-secondary-300 rounded"
            checked={settings.notifications.email_notifications}
            onChange={(e) => handleInputChange('notifications', 'email_notifications', e.target.checked)}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div>
            <label className="text-sm font-medium text-secondary-700">Notifications par SMS</label>
            <p className="text-sm text-secondary-500">Recevoir des notifications par SMS</p>
          </div>
          <input
            type="checkbox"
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-secondary-300 rounded"
            checked={settings.notifications.sms_notifications}
            onChange={(e) => handleInputChange('notifications', 'sms_notifications', e.target.checked)}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div>
            <label className="text-sm font-medium text-secondary-700">Campagne terminée</label>
            <p className="text-sm text-secondary-500">Notifier quand une campagne est terminée</p>
          </div>
          <input
            type="checkbox"
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-secondary-300 rounded"
            checked={settings.notifications.campaign_completed}
            onChange={(e) => handleInputChange('notifications', 'campaign_completed', e.target.checked)}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div>
            <label className="text-sm font-medium text-secondary-700">Échec de livraison</label>
            <p className="text-sm text-secondary-500">Notifier en cas d'échec de livraison</p>
          </div>
          <input
            type="checkbox"
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-secondary-300 rounded"
            checked={settings.notifications.delivery_failed}
            onChange={(e) => handleInputChange('notifications', 'delivery_failed', e.target.checked)}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div>
            <label className="text-sm font-medium text-secondary-700">Résumé quotidien</label>
            <p className="text-sm text-secondary-500">Recevoir un résumé quotidien</p>
          </div>
          <input
            type="checkbox"
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-secondary-300 rounded"
            checked={settings.notifications.daily_summary}
            onChange={(e) => handleInputChange('notifications', 'daily_summary', e.target.checked)}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div>
            <label className="text-sm font-medium text-secondary-700">Rapport hebdomadaire</label>
            <p className="text-sm text-secondary-500">Recevoir un rapport hebdomadaire</p>
          </div>
          <input
            type="checkbox"
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-secondary-300 rounded"
            checked={settings.notifications.weekly_report}
            onChange={(e) => handleInputChange('notifications', 'weekly_report', e.target.checked)}
          />
        </div>
      </div>
    </div>
  );

  const renderSecuritySettings = () => (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-secondary-900">Paramètres de sécurité</h3>
        <p className="text-sm text-secondary-500">Configurez la sécurité de votre compte</p>
      </div>
      
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <label className="text-sm font-medium text-secondary-700">Authentification à deux facteurs</label>
            <p className="text-sm text-secondary-500">Ajouter une couche de sécurité supplémentaire</p>
          </div>
          <input
            type="checkbox"
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-secondary-300 rounded"
            checked={settings.security.two_factor_auth}
            onChange={(e) => handleInputChange('security', 'two_factor_auth', e.target.checked)}
          />
        </div>
        
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label className="block text-sm font-medium text-secondary-700">Délai d'expiration de session (minutes)</label>
            <input
              type="number"
              className="input mt-1"
              value={settings.security.session_timeout}
              onChange={(e) => handleInputChange('security', 'session_timeout', parseInt(e.target.value))}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-secondary-700">Expiration du mot de passe (jours)</label>
            <input
              type="number"
              className="input mt-1"
              value={settings.security.password_expiry}
              onChange={(e) => handleInputChange('security', 'password_expiry', parseInt(e.target.value))}
            />
          </div>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-secondary-700">Tentatives de connexion autorisées</label>
          <input
            type="number"
            className="input mt-1"
            value={settings.security.login_attempts}
            onChange={(e) => handleInputChange('security', 'login_attempts', parseInt(e.target.value))}
          />
        </div>
      </div>
    </div>
  );

  const renderApiSettings = () => (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-secondary-900">Configuration API</h3>
        <p className="text-sm text-secondary-500">Paramètres pour l'intégration API</p>
      </div>
      
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <div className="flex">
          <AlertTriangle className="h-5 w-5 text-yellow-400" />
          <div className="ml-3">
            <h3 className="text-sm font-medium text-yellow-800">Documentation API</h3>
            <div className="mt-2 text-sm text-yellow-700">
              <p>Consultez la documentation complète de l'API pour intégrer SMS Gateway dans vos applications.</p>
            </div>
            <div className="mt-4">
              <button className="btn btn-secondary text-sm">
                Voir la documentation
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-secondary-700">URL de base de l'API</label>
          <input
            type="url"
            className="input mt-1"
            value="https://api.smsgateway.com/v1"
            readOnly
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-secondary-700">Version de l'API</label>
          <input
            type="text"
            className="input mt-1"
            value="v1.0"
            readOnly
          />
        </div>
      </div>
    </div>
  );

  const renderDatabaseSettings = () => (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-secondary-900">Gestion de la base de données</h3>
        <p className="text-sm text-secondary-500">Outils de maintenance et sauvegarde</p>
      </div>
      
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <div className="card">
          <h4 className="text-lg font-medium text-secondary-900 mb-2">Sauvegarde</h4>
          <p className="text-sm text-secondary-500 mb-4">
            Créez une sauvegarde complète de votre base de données
          </p>
          <button className="btn btn-primary">
            Créer une sauvegarde
          </button>
        </div>
        
        <div className="card">
          <h4 className="text-lg font-medium text-secondary-900 mb-2">Restauration</h4>
          <p className="text-sm text-secondary-500 mb-4">
            Restaurez la base de données depuis une sauvegarde
          </p>
          <button className="btn btn-secondary">
            Restaurer
          </button>
        </div>
        
        <div className="card">
          <h4 className="text-lg font-medium text-secondary-900 mb-2">Optimisation</h4>
          <p className="text-sm text-secondary-500 mb-4">
            Optimisez les performances de la base de données
          </p>
          <button className="btn btn-secondary">
            Optimiser
          </button>
        </div>
        
        <div className="card">
          <h4 className="text-lg font-medium text-secondary-900 mb-2">Statistiques</h4>
          <p className="text-sm text-secondary-500 mb-4">
            Consultez les statistiques de la base de données
          </p>
          <button className="btn btn-secondary">
            Voir les statistiques
          </button>
        </div>
      </div>
    </div>
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case 'profile':
        return renderProfileSettings();
      case 'sms':
        return renderSmsSettings();
      case 'notifications':
        return renderNotificationSettings();
      case 'security':
        return renderSecuritySettings();
      case 'api':
        return renderApiSettings();
      case 'database':
        return renderDatabaseSettings();
      default:
        return renderProfileSettings();
    }
  };

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div>
        <h1 className="text-2xl font-bold text-secondary-900">Paramètres</h1>
        <p className="mt-1 text-sm text-secondary-500">
          Gérez les paramètres de votre compte et de l'application
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-6">
        {/* Navigation des onglets */}
        <div className="lg:w-64">
          <nav className="space-y-1">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-lg ${
                    activeTab === tab.id
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-secondary-700 hover:bg-secondary-100 hover:text-secondary-900'
                  }`}
                >
                  <Icon className="mr-3 h-5 w-5" />
                  {tab.name}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Contenu des onglets */}
        <div className="flex-1">
          <div className="card">
            {renderTabContent()}
            
            <div className="mt-8 pt-6 border-t border-secondary-200">
              <div className="flex justify-end">
                <button
                  onClick={handleSave}
                  className="btn btn-primary"
                >
                  <Save className="h-4 w-4 mr-2" />
                  Sauvegarder les modifications
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
